import React from 'react';
import PropTypes from 'prop-types';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import CrmShipment from '../../../../classes/CrmShipment';

function OrderShipmentList({
  shipmentList, remainingItems, showRemainingItems, onTrackClick, dataError, onCloseError,
}) {
  return (
    <>
      {dataError && (
        <div className="row">
          <div className="col">
            <ErrorBanner onCloseError={onCloseError}>
              Unexpected Error retrieving shipment details.
            </ErrorBanner>
          </div>
        </div>
      )}
      {shipmentList.map(((shipment, index) => (
        <div key={index}>
          <b>
            {shipment.carrier}
            {' '}
            {shipment.shipMethod}
            {' '}
          </b>
          <span className="font-italic">
            {shipment.shipmentItemQuantity}
            {' '}
            items
          </span>
          {' '}
          {shipment.trackingNumber}
          {' '}
          <button
            type="button"
            className="btn btn-sm btn-link mb-1"
            onClick={() => onTrackClick(shipment.id)}
          >
            {' '}
            <u>
              track shipment
            </u>
          </button>
        </div>
      )))}
      {showRemainingItems && (
        <div className="font-italic">
          {remainingItems}
          {' '}
          additional items remaining to be shipped.
        </div>
      )}
    </>
  );
}

OrderShipmentList.propTypes = {
  shipmentList: PropTypes.arrayOf(PropTypes.shape(CrmShipment)).isRequired,
  remainingItems: PropTypes.number,
  showRemainingItems: PropTypes.bool,
  onTrackClick: PropTypes.func.isRequired,
  dataError: PropTypes.bool.isRequired,
  onCloseError: PropTypes.func.isRequired,
};

OrderShipmentList.defaultProps = {
  remainingItems: 0,
  showRemainingItems: false,
};

export default OrderShipmentList;
